
import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/adresses')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") {        
        return Api.put('api/adresses/' + id , payload)       
    } else {
        return Api.post('api/adresses' , payload)       
    }    
};

const getById =  (payload) => {        
    return Api.get('api/adresses/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/adresses/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};